import Sidebar from "../Sidebar/Sidebar";
import { Switch, Route, useLocation } from "react-router-dom";
import "./PracticeLayout.css";
import PracticeDashboard from "../tests/Dashboard/PracticeDashboard";
import AitsPage from "../aits/pages/AitsPage";
import PyqTopicWise from "../aits/components/Header/PaperListing/PyqTopicWise";
import PyqTopicWiseSet from "../aits/components/Header/PaperListing/PyqTopicWiseSet";
import MistakeBookPage from "../MistakeBook/MistakeBookPage";
import WeakAreaAnalysisPage from "../MistakeBook/WeakAreaAnalysisPage";
import PracticeSetsPage from "../MistakeBook/PracticeSetsPage";
import MistakeBookPracticeSetAnalyticsPage from "../MistakeBook/MistakeBookPracticeSetAnalyticsPage";
import PracticeSetInstructionPage from "../MistakeBook/PracticeSetInstructionPage";
import MistakeBookTopicQuestionsPage from "../MistakeBook/MistakeBookTopicQuestionsPage";
import MistakeBookQuestionDetailPage from "../MistakeBook/MistakeBookQuestionDetailPage";
import MistakeBookSuccessPage from "../MistakeBook/MistakeBookSuccessPage";

const PracticeLayout = () => {
  const location = useLocation();
  const hideSidebar = location.pathname.startsWith("/practice/mistake-book");

  return (
    <div
      className={`practice-layout${
        hideSidebar ? " practice-layout--no-sidebar" : ""
      }`}
    >
      {!hideSidebar ? <Sidebar /> : null}
      <div className="practice-content">
        <Switch>
          <Route exact path="/practice" component={PracticeDashboard} />
          <Route
            exact
            path="/practice/mistake-book/weak-area-analysis"
            component={WeakAreaAnalysisPage}
          />
          <Route
            exact
            path="/practice/mistake-book/practice-sets/analytics"
            component={MistakeBookPracticeSetAnalyticsPage}
          />
          <Route
            exact
            path="/practice/mistake-book/practice-sets"
            component={PracticeSetsPage}
          />
          <Route
            exact
            path="/practice/mistake-book/practice-set-instruction"
            component={PracticeSetInstructionPage}
          />
          <Route
            exact
            path="/practice/mistake-book/topic-questions"
            component={MistakeBookTopicQuestionsPage}
          />
          <Route
            exact
            path="/practice/mistake-book/question-detail"
            component={MistakeBookQuestionDetailPage}
          />
          <Route
            exact
            path="/practice/mistake-book/success"
            component={MistakeBookSuccessPage}
          />
          <Route exact path="/practice/mistake-book" component={MistakeBookPage} />
          <Route path="/practice/topic-wise/pyqset" component={PyqTopicWiseSet} />
          <Route path="/practice/topic-wise" component={PyqTopicWise} />
          <Route path="/practice/paper-listing" component={AitsPage} />
        </Switch>
      </div>
    </div>
  );
};

export default PracticeLayout;
